import { AxiosResponse } from "axios";
import { saveAs } from "file-saver";
import * as _ from "lodash";

export function repeatFunction(
  func: (...params: any) => void,
  time: number,
  ...params: any
) {
  for (let i = 0; i < time; i++) {
    func(...params);
  }
}

export function getFileFromBlob(response: AxiosResponse<any>) {
  const fileName = response.headers["content-disposition"]
    .split(";")
    .find((n: any) => n.includes("filename="))
    .replace("filename=", "")
    .trim();
  const url = window.URL.createObjectURL(
    new Blob([response.data], {
      type: "application/octet-stream",
    })
  );
  saveAs(url, fileName);
}

export function getFileUtf8FromBlob(response: AxiosResponse<any>) {
  const fileName = decodeURI(
    response.headers["content-disposition"]
      .split(";")
      .find((n: any) => n.includes("filename*="))
      .replace("filename*=UTF-8''", "")
      .trim()
  );
  const url = window.URL.createObjectURL(
    new Blob([response.data], {
      type: "application/octet-stream",
    })
  );
  saveAs(url, fileName);
}

export function sumByChild(
  tableData: any[],
  currentItem: any,
  sumByField: string
): any[] {
  const newArr = _.cloneDeep(tableData);
  const foundParentIndex = newArr.findIndex(
    (e) => e.biddingPackageId === currentItem.biddingPackage.parentId
  );
  if (foundParentIndex > -1) {
    const child = newArr.filter(
      (e) =>
        e.biddingPackage.parentId === newArr[foundParentIndex].biddingPackageId
    );
    newArr[foundParentIndex][sumByField] = _.sumBy(child, sumByField);

    if (newArr[foundParentIndex].biddingPackage.parentId != null) {
      sumByChild(newArr, newArr[foundParentIndex], sumByField);
    }
  }
  return newArr;
}

export function parseJSON(data: any) {
  try {
    return JSON.parse(data);
  } catch (error) {
    console.error("Invalid JSON data:", error);
    return [];
  }
}
